import {
	PATCH_DEFICIENCY,
	GET_DEFICIENCY_BY_ID,
	REMOVE_DOCUMENT_FROM_DEFICIENCY,
	ADD_PARENT_DEFICIENCY,
	REMOVE_PARENT_DEFICIENCY,
	REFRESH_DEFICIENCY_ON_UPDATE,
	POST_RNH_NEW_NOTE,
	UPDATE_RNH_NOTE_DETAIL,
	ADD_CONTROL_TO_DEFICIENCY,
	REMOVE_CONTROL_FROM_DEFICIENCY,
	ADD_ITCONTROL_TO_DEFICIENCY,
	REMOVE_ITCONTROL_FROM_DEFICIENCY,
	ADD_TAG_TO_DEFICIENCY,
	REMOVE_TAG_FROM_DEFICIENCY,
	UPDATE_ENGAGEMENT_TAG,
	DELETE_ENGAGEMENT_TAG,
	ADD_ITRISK_TO_DEFICIENCY,
	REMOVE_ITRISK_FROM_DEFICIENCY,
	PATCH_DEFICIENCY_ITRISK_TYPE,
	SAVE_NOT_IMPACTED_RATIONALE,
	FETCH_NOT_IMPACTED_CONTROLS_MODAL_DATA,
	UPDATE_DOCUMENT_ON_SIGNOFF_REMOVAL,
	UPDATE_DOCUMENT_ON_ADDING_SIGNOFF
} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {formBodyType, controlDeficiencyType, HttpStatusCodes} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';
import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';

export function deficiencyReducer(state = initialstate.deficiency, action) {
	switch (action.type) {
		case PATCH_DEFICIENCY: {
			if (isApiResponseOk(action)) {
				const patches = action.meta?.api?.data || [];
				if (!patches.length) return state;

				const pathMap = {
					'/remediationDate': 'remediationDate',
					'/startDate': 'startDate'
				};

				let updatedState = state;

				for (const patch of patches) {
					if (patch.op === 'replace' && pathMap[patch.path]) {
						updatedState = {
							...updatedState,
							[pathMap[patch.path]]: patch.value
						};
					}
				}
				return updatedState;
			}
			return state;
		}

		case GET_DEFICIENCY_BY_ID: {
			if (isApiResponseOk(action)) {
				const bodyTypeIds = [];

				if (Array.isArray(action.bodyTypeIds)) {
					bodyTypeIds.push(...action.bodyTypeIds);
				}

				if (action.actionArgs && action.actionArgs.formBodyTypeId) {
					bodyTypeIds.push(action.actionArgs.formBodyTypeId);
				}

				const updatedState =
					state.id === action.response?.id && bodyTypeIds.length > 0 && Object.keys(state).length > 0 ? {...state} : {...(action.response || {})};
				for (const bodyTypeId of bodyTypeIds) {
					switch (bodyTypeId) {
						case formBodyType.RelateControlToDeficiency:
							updatedState.relatedDeficientControls = action.response?.relatedDeficientControls || [];
							updatedState.relatedCompensatingControls = action.response?.relatedCompensatingControls || [];
							updatedState.relatedMitigatingControls = action.response?.relatedMitigatingControls || [];
							break;
						case formBodyType.RelateCompensatingControlsToDeficiency:
							updatedState.relatedCompensatingControls = action.response?.relatedCompensatingControls || [];
							updatedState.relatedDeficientControls = action.response?.relatedDeficientControls || [];
							updatedState.relatedMitigatingControls = action.response?.relatedMitigatingControls || [];
							break;
						case formBodyType.RelateAssertionToDeficiency:
							updatedState.relatedAssertionRisks = action.response?.relatedAssertionRisks || [];
							break;
						case formBodyType.RelateSTEntityToDeficiency:
							updatedState.relatedSTEntities = action.response?.relatedSTEntities || [];
							break;
						case formBodyType.RelateGAComponentToDeficiency:
							updatedState.relatedGroupComponents = action.response?.relatedGroupComponents || [];
							break;
						case formBodyType.RelateITControlToDeficiency:
							updatedState.relatedDeficientITControls = action.response?.relatedDeficientITControls || [];
							updatedState.relatedCompensatingITControls = action.response?.relatedCompensatingITControls || [];
							updatedState.relatedMitigatingITControls = action.response?.relatedMitigatingITControls || [];
							updatedState.relatedNotImpactedITControls = action.response?.relatedNotImpactedITControls || [];
							break;
						case formBodyType.RelateITRiskToDeficiency:
							updatedState.relatedITApplications = action.response?.relatedITApplications || [];
							updatedState.relatedITRisks = action.response?.relatedITRisks || [];
							updatedState.relatedDeficientITControls = action.response?.relatedDeficientITControls || [];
							break;
						case formBodyType.RelateUnmitigatedITRiskToDeficiency:
							updatedState.relatedITRisks = action.response?.relatedITRisks || [];
							break;
						case formBodyType.RelateCompensatingITControlsToDeficiency:
							updatedState.relatedCompensatingITControls = action.response?.relatedCompensatingITControls || [];
							updatedState.relatedDeficientITControls = action.response?.relatedDeficientITControls || [];
							break;
						case formBodyType.RelateMitigatingITControlsToDeficiency:
							updatedState.relatedMitigatingITControls = action.response?.relatedMitigatingITControls || [];
							break;
						case formBodyType.DeficiencyITGCRelatedUpstreamDeficiencies:
						case formBodyType.RelateChildDeficiencies:
						case formBodyType.DeficiencyRelatedParentDeficiency:
							updatedState.relatedChildDeficiencies = mapDeficiencies(action.response?.relatedDeficiencies?.childDeficiencies);
							updatedState.relatedParentDeficiencies = mapDeficiencies(action.response?.relatedDeficiencies?.parentDeficiencies);
							updatedState.relatedChildDeficienciesDocuments = mapDeficiencyDocuments(action.response?.relatedDeficiencies?.childDeficiencies);
							updatedState.relatedParentDeficienciesDocuments = mapDeficiencyDocuments(action.response?.relatedDeficiencies?.parentDeficiencies);
							updatedState.impactedControls = action.response?.impactedControls || [];
							updatedState.impactedITControls = action.response?.impactedITControls || [];
							break;
						case formBodyType.DeficiencyRelatedDocuments:
							updatedState.relatedDocuments = action.response?.relatedDocuments || [];
							break;
						case formBodyType.RelateMitigatingControlsToDeficiency:
							updatedState.relatedDeficientControls = action.response?.relatedDeficientControls || [];
							updatedState.relatedMitigatingControls = action.response?.relatedMitigatingControls || [];
							updatedState.relatedCompensatingControls = action.response?.relatedCompensatingControls || [];
							break;
						case formBodyType.RelateNotImpactedControlsToDeficiency307:
							updatedState.relatedNotImpactedControls = action.response?.relatedNotImpactedControls || [];
							updatedState.relatedNotImpactedITControls = action.response?.relatedNotImpactedITControls || [];
							break;
						case formBodyType.DisplayDeficiencyProperties:
							updatedState.entityId = action.response?.entityId;
							updatedState.description = action.response?.description;
							updatedState.deficiencyShortName = action.response?.deficiencyShortName;
							updatedState.deficiencyTags = action.response?.deficiencyTags || [];
							break;
					}
				}

				// Store impacted controls from response if present
				if (action.response?.impactedControls) {
					updatedState.impactedControls = action.response.impactedControls;
				}
				if (action.response?.impactedITControls) {
					updatedState.impactedITControls = action.response.impactedITControls;
				}

				return updatedState;
			}

			return action.response || state;
		}

		case REMOVE_DOCUMENT_FROM_DEFICIENCY: {
			if (!action.documentId || !state.relatedDocuments?.length) return state;
			return {...state, relatedDocuments: state.relatedDocuments.filter((d) => d.id !== action.documentId)};
		}

		case ADD_PARENT_DEFICIENCY: {
			if (!isApiResponseOk(action) || !action.actionArgs) {
				return state;
			}

			const item = action.actionArgs.deficiencyItem;

			const formattedItem = {
				deficiencyId: item.id || item.deficiencyId,
				deficiencyShortName: item.deficiencyShortName,
				description: item.description,
				isControlRemediated: item.isControlRemediated || false
			};

			const childFormBodyTypes = [formBodyType.RelateChildDeficiencies, formBodyType.DeficiencyITGCRelatedUpstreamDeficiencies];

			if (childFormBodyTypes.includes(action.actionArgs.formBodyTypeId)) {
				return {...state, relatedChildDeficiencies: [...(state.relatedChildDeficiencies || []), formattedItem]};
			}

			if (action.actionArgs.formBodyTypeId === formBodyType.DeficiencyRelatedParentDeficiency) {
				return {...state, relatedParentDeficiencies: [...(state.relatedParentDeficiencies || []), formattedItem]};
			}

			return state;
		}

		case REMOVE_PARENT_DEFICIENCY: {
			if (!isApiResponseOk(action) || !action.actionArgs) {
				return state;
			}

			const childFormBodyTypes = [formBodyType.RelateChildDeficiencies, formBodyType.DeficiencyITGCRelatedUpstreamDeficiencies];

			if (childFormBodyTypes.includes(action.actionArgs.formBodyTypeId)) {
				return {
					...state,
					relatedChildDeficiencies: (state.relatedChildDeficiencies || []).filter((d) => d.deficiencyId !== action.actionArgs.deficiencyItem.id)
				};
			}

			if (action.actionArgs.formBodyTypeId === formBodyType.DeficiencyRelatedParentDeficiency) {
				return {
					...state,
					relatedParentDeficiencies: (state.relatedParentDeficiencies || []).filter((d) => d.deficiencyId !== action.actionArgs.deficiencyItem.id)
				};
			}

			return state;
		}

		case REFRESH_DEFICIENCY_ON_UPDATE: {
			const {payload: deficiency} = action;
			const updatedState = cloneDeep(state);
			updatedState.deficiencyShortName = deficiency.deficiencyShortName;
			updatedState.description = deficiency.deficiencyDescription;

			return updatedState;
		}

		case POST_RNH_NEW_NOTE: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			if (!action.noteInfo || !action.noteInfo.documentId) {
				return state;
			}

			if (!state.relatedChildDeficienciesDocuments?.length && !state.relatedParentDeficienciesDocuments?.length) {
				return state;
			}

			const documentId = action.noteInfo.documentId;
			const currentState = cloneDeep(state);

			const getUpdatedDocuments = (documents) => {
				const documentIdx = documents.findIndex((d) => d.id === documentId);

				if (documentIdx === -1) {
					return documents;
				}

				const document = documents[documentIdx];
				document.engagementReviewNoteCount = (document.engagementReviewNoteCount || 0) + 1;

				return documents;
			};

			if (currentState.relatedChildDeficienciesDocuments?.length) {
				currentState.relatedChildDeficienciesDocuments = getUpdatedDocuments(currentState.relatedChildDeficienciesDocuments);
			}

			if (currentState.relatedParentDeficienciesDocuments?.length) {
				currentState.relatedParentDeficienciesDocuments = getUpdatedDocuments(currentState.relatedParentDeficienciesDocuments);
			}

			return currentState;
		}

		case UPDATE_RNH_NOTE_DETAIL: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			if (!action.commentData || !action.commentData.documentId || !action.commentData.statusIdChanged) {
				return state;
			}

			if (!state.relatedChildDeficienciesDocuments?.length && !state.relatedParentDeficienciesDocuments?.length) {
				return state;
			}

			const {documentId, isOpening, isClosing} = action.commentData;
			const currentState = cloneDeep(state);

			const getUpdatedDocuments = (documents) => {
				const documentIdx = documents.findIndex((d) => d.id === documentId);

				if (documentIdx === -1) {
					return documents;
				}

				const document = documents[documentIdx];
				if (isOpening) {
					document.engagementReviewNoteCount = (document.engagementReviewNoteCount || 0) + 1;
				} else if (isClosing) {
					document.engagementReviewNoteCount = Math.max((document.engagementReviewNoteCount || 0) - 1, 0);
				}

				return documents;
			};

			if (currentState.relatedChildDeficienciesDocuments?.length) {
				currentState.relatedChildDeficienciesDocuments = getUpdatedDocuments(currentState.relatedChildDeficienciesDocuments);
			}

			if (currentState.relatedParentDeficienciesDocuments?.length) {
				currentState.relatedParentDeficienciesDocuments = getUpdatedDocuments(currentState.relatedParentDeficienciesDocuments);
			}

			return currentState;
		}

		case ADD_ITCONTROL_TO_DEFICIENCY: {
			if (!action.response || !action.response.deficiencyId || !action.response.itControlId) return state;
			let newItems = [];
			let controlDeficiencyTypeId = controlDeficiencyType.DeficientControl;
			if (action.actionArgs?.itControlItems) {
				newItems = Array.isArray(action.actionArgs.itControlItems) ? action.actionArgs.itControlItems : [action.actionArgs.itControlItems];
				controlDeficiencyTypeId = action.actionArgs?.itControlItems.controlDeficiencyTypeId;
			}
			const updatedState = cloneDeep(state);
			if (controlDeficiencyTypeId === controlDeficiencyType.NotImpactedControl) {
				if (!updatedState.notImpactedControlsModal) return state;
				return {
					...updatedState,
					notImpactedControlsModal: {
						...updatedState.notImpactedControlsModal,
						selectedITControlIds: [...updatedState.notImpactedControlsModal.selectedITControlIds, action.response.itControlId]
					}
				};
			}
			if (controlDeficiencyTypeId === controlDeficiencyType.MitigatingControl) {
				const currentRelated = updatedState.relatedMitigatingITControls || [];
				return {
					...updatedState,
					relatedMitigatingITControls: [...currentRelated, ...newItems]
				};
			}
			if (controlDeficiencyTypeId === controlDeficiencyType.CompensatingControl) {
				const currentRelated = updatedState.relatedCompensatingITControls || [];
				return {
					...updatedState,
					relatedCompensatingITControls: [...currentRelated, ...newItems]
				};
			}
			const currentRelated = updatedState.relatedDeficientITControls || [];
			return {
				...updatedState,
				relatedDeficientITControls: [...currentRelated, ...newItems]
			};
		}

		case REMOVE_ITCONTROL_FROM_DEFICIENCY: {
			if (!action.payload) return state;
			const itControlId = action.payload;
			const updatedState = cloneDeep(state);
			const controlDeficiencyTypeId = action.actionArgs?.controlDeficiencyTypeId;
			if (controlDeficiencyTypeId === controlDeficiencyType.NotImpactedControl) {
				if (!updatedState.notImpactedControlsModal) return state;
				return {
					...updatedState,
					notImpactedControlsModal: {
						...updatedState.notImpactedControlsModal,
						selectedITControlIds: updatedState.notImpactedControlsModal.selectedITControlIds.filter((id) => id !== itControlId)
					}
				};
			}
			if (controlDeficiencyTypeId === controlDeficiencyType.MitigatingControl) {
				const currentRelated = Array.isArray(updatedState.relatedMitigatingITControls) ? updatedState.relatedMitigatingITControls : [];
				const updatedRelated = currentRelated.filter((ctrl) => ctrl.itControlId !== itControlId);
				return {
					...updatedState,
					relatedMitigatingITControls: updatedRelated
				};
			}
			if (controlDeficiencyTypeId === controlDeficiencyType.CompensatingControl) {
				const currentRelated = Array.isArray(updatedState.relatedCompensatingITControls) ? updatedState.relatedCompensatingITControls : [];
				const updatedRelated = currentRelated.filter((ctrl) => ctrl.itControlId !== itControlId);
				return {
					...updatedState,
					relatedCompensatingITControls: updatedRelated
				};
			}
			const currentRelated = Array.isArray(updatedState.relatedDeficientITControls) ? updatedState.relatedDeficientITControls : [];
			const updatedRelated = currentRelated.filter((ctrl) => ctrl.itControlId !== itControlId);
			return {
				...updatedState,
				relatedDeficientITControls: updatedRelated
			};
		}

		case ADD_CONTROL_TO_DEFICIENCY: {
			if (!isApiResponseOk(action)) return state;
			const addControlPayload = action.meta?.api?.data || {};
			if (addControlPayload.controlDeficiencyType !== controlDeficiencyType.NotImpactedControl || !state.notImpactedControlsModal) return state;
			return {
				...state,
				notImpactedControlsModal: {
					...state.notImpactedControlsModal,
					selectedControlIds: [...state.notImpactedControlsModal.selectedControlIds, addControlPayload.controlId]
				}
			};
		}

		case REMOVE_CONTROL_FROM_DEFICIENCY: {
			if (!isApiResponseOk(action) || !action.payload) return state;
			if (action.actionArgs?.controlDeficiencyTypeId !== controlDeficiencyType.NotImpactedControl || !state.notImpactedControlsModal) return state;
			return {
				...state,
				notImpactedControlsModal: {
					...state.notImpactedControlsModal,
					selectedControlIds: state.notImpactedControlsModal.selectedControlIds.filter((id) => id !== action.payload)
				}
			};
		}

		case FETCH_NOT_IMPACTED_CONTROLS_MODAL_DATA: {
			if (!isApiResponseOk(action)) return state;
			const response = action.response || {};
			const EXCLUDED_TYPES = [controlDeficiencyType.DeficientControl, controlDeficiencyType.CompensatingControl, controlDeficiencyType.MitigatingControl];

			const controls = (response.impactedControls || [])
				.filter((item) => !EXCLUDED_TYPES.includes(item.controlDeficiencyTypeId))
				.map((item) => ({...item, id: item.controlId}));

			const itControls = (response.impactedITControls || [])
				.filter((item) => !EXCLUDED_TYPES.includes(item.controlDeficiencyTypeId))
				.map((item) => ({...item, id: item.itControlId}));

			return {
				...state,
				notImpactedControlsModal: {
					controls,
					itControls,
					selectedControlIds: controls.filter((item) => item.controlDeficiencyTypeId === controlDeficiencyType.NotImpactedControl).map((item) => item.id),
					selectedITControlIds: itControls.filter((item) => item.controlDeficiencyTypeId === controlDeficiencyType.NotImpactedControl).map((item) => item.id)
				}
			};
		}

		case SAVE_NOT_IMPACTED_RATIONALE: {
			if (!isApiResponseOk(action) || !action.actionArgs) return state;

			const {id, isITControl, rationale} = action.actionArgs;
			const key = isITControl ? 'relatedNotImpactedITControls' : 'relatedNotImpactedControls';
			const idKey = isITControl ? 'itControlId' : 'controlId';
			const items = Array.isArray(state[key]) ? state[key] : [];

			return {
				...state,
				[key]: items.map((item) => (item?.[idKey] === id ? {...item, rationale} : item))
			};
		}

		case ADD_TAG_TO_DEFICIENCY: {
			if (!isApiResponseOk(action) || !action.actionArgs?.tag) return state;
			const item = action.actionArgs.tag;
			const formattedItem = {
				engagementTagId: item.id || item.engagementTagId,
				engagementTagGroupId: null,
				engagementTagName: item.engagementTagName,
				colorCode: item.colorCode
			};
			return {...state, deficiencyTags: [...(state.deficiencyTags || []), formattedItem]};
		}

		case REMOVE_TAG_FROM_DEFICIENCY: {
			if (!isApiResponseOk(action)) return state;
			const tagId = action.actionArgs?.tag?.id ?? action.actionArgs?.tag?.engagementTagId;
			return {
				...state,
				deficiencyTags: (state.deficiencyTags || []).filter((d) => d.engagementTagId !== tagId)
			};
		}

		case UPDATE_ENGAGEMENT_TAG: {
			if (!isApiResponseOk(action)) return state;

			const updatedTagId = action.response?.tagId;
			if (!updatedTagId || !Array.isArray(state.deficiencyTags)) return state;

			return {
				...state,
				deficiencyTags: state.deficiencyTags.map((tag) =>
					tag.engagementTagId === updatedTagId
						? {
								...tag,
								engagementTagName: action.response?.name,
								colorCode: action.response?.colorCode
							}
						: tag
				)
			};
		}

		case DELETE_ENGAGEMENT_TAG: {
			const isDeleted = action.responseObj?.status === HttpStatusCodes.NoContent || action?.error?.response?.status === HttpStatusCodes.NotFound;
			if (!isDeleted || !Array.isArray(state.deficiencyTags)) return state;

			return {
				...state,
				deficiencyTags: state.deficiencyTags.filter((tag) => tag.engagementTagId !== action.tagId)
			};
		}

		case ADD_ITRISK_TO_DEFICIENCY: {
			if (!isApiResponseOk(action) || !action.actionArgs?.itRiskItems?.length) return state;
			const newItems = action.actionArgs.itRiskItems;

			return {
				...state,
				relatedITRisks: [...(state.relatedITRisks || []), ...newItems]
			};
		}

		case REMOVE_ITRISK_FROM_DEFICIENCY: {
			if (!isApiResponseOk(action)) return state;
			const requestData = action.meta?.api?.data || {};
			const {knowledgeITRiskId, itRiskId, deficiencyITRiskId} = requestData;

			if (!knowledgeITRiskId && !itRiskId && !deficiencyITRiskId) return state;

			return {
				...state,
				relatedITRisks: (state.relatedITRisks || []).filter((risk) => {
					if (knowledgeITRiskId) return risk.knowledgeITRiskId !== knowledgeITRiskId;
					if (itRiskId) return risk.itRiskId !== itRiskId;
					if (deficiencyITRiskId) return risk.deficiencyITRiskId !== deficiencyITRiskId;
					return true;
				})
			};
		}

		case PATCH_DEFICIENCY_ITRISK_TYPE: {
			if (!isApiResponseOk(action)) return state;
			const {itRiskIds, deficiencyITRiskTypeId} = action.actionArgs || {};
			if (!itRiskIds?.length) return state;

			const itRiskIdSet = new Set(itRiskIds);
			return {
				...state,
				relatedITRisks: (state.relatedITRisks || []).map((risk) => (itRiskIdSet.has(risk.itRiskId) ? {...risk, deficiencyITRiskTypeId} : risk))
			};
		}

		case UPDATE_DOCUMENT_ON_ADDING_SIGNOFF: {
			if (!state.relatedChildDeficienciesDocuments?.length && !state.relatedParentDeficienciesDocuments?.length) {
				return state;
			}

			if (!action.signOff) {
				return state;
			}

			const getUpdatedDocuments = (documents) => {
				const documentIndex = documents.findIndex((document) => document.id === action.documentId);

				if (documentIndex === -1) {
					return documents;
				}

				const approval = {
					...action.signOff,
					id: action.signOff.approvalId ? action.signOff.approvalId : action.signOff.id
				};

				const updatedDocument = {
					...documents[documentIndex],
					approvals: [approval, ...(documents[documentIndex].approvals || [])]
				};

				const updatedData = [...documents];
				updatedData[documentIndex] = updatedDocument;

				return updatedData;
			};

			const childDocuments = [];
			const parentDocuments = [];

			if (state.relatedChildDeficiencies?.length > 0) {
				childDocuments.push(...getUpdatedDocuments(state.relatedChildDeficienciesDocuments));
			}

			if (state.relatedParentDeficiencies?.length > 0) {
				parentDocuments.push(...getUpdatedDocuments(state.relatedParentDeficienciesDocuments));
			}

			return {
				...state,
				relatedChildDeficienciesDocuments: childDocuments,
				relatedParentDeficienciesDocuments: parentDocuments
			};
		}

		case UPDATE_DOCUMENT_ON_SIGNOFF_REMOVAL: {
			if (!state.relatedChildDeficienciesDocuments?.length && !state.relatedParentDeficienciesDocuments?.length) {
				return state;
			}

			if (!action.documentId || !action.approvalId) {
				return state;
			}

			const getUpdatedDocuments = (documents) => {
				const documentIndex = documents.findIndex((document) => document.id === action.documentId);

				if (documentIndex === -1) {
					return documents;
				}

				const updatedDocument = {
					...documents[documentIndex],
					approvals: (documents[documentIndex].approvals || []).filter((a) => a.id !== action.approvalId)
				};

				const updatedDocuments = [...documents];
				updatedDocuments[documentIndex] = updatedDocument;

				return updatedDocuments;
			};

			const childDocuments = [];
			const parentDocuments = [];

			if (state.relatedChildDeficiencies?.length > 0) {
				childDocuments.push(...getUpdatedDocuments(state.relatedChildDeficienciesDocuments));
			}

			if (state.relatedParentDeficiencies?.length > 0) {
				parentDocuments.push(...getUpdatedDocuments(state.relatedParentDeficienciesDocuments));
			}

			return {
				...state,
				relatedChildDeficienciesDocuments: childDocuments,
				relatedParentDeficienciesDocuments: parentDocuments
			};
		}

		default:
			return state;
	}
}

function mapDeficiencyDocuments(deficiencies = []) {
	const sorted = sortBy(deficiencies, 'deficiencyShortName');

	return sorted.flatMap((item) => {
		const docs = item.relatedDocuments || [];
		if (docs.length === 0) {
			const placeholderId = `deficiency-placeholder-${item.deficiencyId ?? item.deficiencyShortName}`;
			return [
				{
					fileExt: '',
					id: placeholderId,
					documentName: item.deficiencyShortName,
					deficiencyShortName: item.deficiencyShortName,
					deficiencyId: item.deficiencyId,
					isPlaceholderDocument: true
				}
			];
		}
		const hasMultiple = docs.length > 1;
		return docs.map((doc) => ({
			...doc,
			fileExt: '',
			documentName: hasMultiple ? `${item.deficiencyShortName} - ${doc.documentName}` : item.deficiencyShortName,
			deficiencyShortName: item.deficiencyShortName,
			deficiencyId: item.deficiencyId
		}));
	});
}

function mapDeficiencies(deficiencies = []) {
	return deficiencies.map((deficiency) => {
		const documents = deficiency.relatedDocuments || [];

		return {
			...deficiency,
			relatedDocuments: documents.map((document) => document.id)
		};
	});
}
